module.exports = __webpack_public_path__ + "public/img/Pengelolaan Sampah Organik dan Plastik Rumah Tangga.d458da9b.png";